import type React from "react";
import { useShipperContractCreatProps } from "./fetch";
import { MasterDataVehicleCreatePageUi } from "./ui";

export const MasterDataVehicleCreatePage: React.FC = () => {
  const props = useShipperContractCreatProps();
  return <MasterDataVehicleCreatePageUi {...props} />;
};
